var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass:
        "flex px-2 text-center cursor-default rounded-xl whitespace-no-wrap",
      class: _vm.classes,
    },
    [_vm._v(" " + _vm._s(_vm.value) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }